export interface CooperativeRenderOptions {
  yieldEvery?: number;
  yieldControl?: () => Promise<void>;
}

function nextFrame(): Promise<void> {
  return new Promise((resolve) => requestAnimationFrame(() => resolve()));
}

export async function cooperativelyVisit<T>(
  values: Iterable<T>,
  signal: AbortSignal,
  visit: (value: T, index: number) => void,
  options: CooperativeRenderOptions = {},
): Promise<void> {
  const yieldEvery = options.yieldEvery ?? 2_048;
  const yieldControl = options.yieldControl ?? nextFrame;
  let index = 0;
  for (const value of values) {
    if (signal.aborted) throw new DOMException("Render cancelled", "AbortError");
    visit(value, index);
    index += 1;
    if (index % yieldEvery === 0) {
      await yieldControl();
      if (signal.aborted) throw new DOMException("Render cancelled", "AbortError");
    }
  }
}
